import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Workbench } from '@tanium/react-workbench';
import { useRoutes } from '../../Routes';
import { OverviewPage } from '../../pages/OverviewPage';
import { useCurrentRoute } from './useCurrentRoute';
import { CMP } from '../../pages/CloudManagement/CMP';
import { Artifacts } from '../../pages/Artifacts/Artifacts';
import { EventHistorySection } from '../../pages/EventHistory/EventHistorySection';
import { OtherServiceSection } from '../../pages/OtherServices/OtherServiceSection';
import { CaseManagementSection } from '../../pages/CaseManagement/CaseManagementSection';
import { LicensesPage } from '../../pages/Licenses/LicensesPage';
import { CreateTaniumInstancePage } from '../../pages/CreateTaniumInstance/CreateTaniumInstancePage';

export const AppContent: React.VFC = () => {
  const currentRoute = useCurrentRoute();
  const { WORKSPACE, ROUTES } = useRoutes();

  return (
    <Workbench
      productName={WORKSPACE.sectionName}
      homeUrl={WORKSPACE.url}
      currentPageLabel={WORKSPACE.pageName}
      breadcrumbs={[]}
      icon={WORKSPACE.icon}
      defaultSections={ROUTES}
      sections={ROUTES}
      renderedRoute={currentRoute}
    >
      <Switch>
        <Route path={'/create-instance'} component={CreateTaniumInstancePage} />
        <Route path={'/instance'} component={CMP} />
        <Route path={'/artifacts'} component={Artifacts} />
        <Route path={'/account-history'} component={EventHistorySection} />
        <Route path={'/case-management'} component={CaseManagementSection} />
        <Route path={'/licenses'} component={LicensesPage} />
        <Route path={'/other-services'} component={OtherServiceSection} />
        <Route path={'/'} component={OverviewPage} />
      </Switch>
    </Workbench>
  );
};
